import { useSelector, useDispatch } from 'react-redux';
import {
  getAnalyticsConfigData,
  changeDateRange,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  handleSetMultipleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleRemoveFeatureExtraFilterData,
  setFeatureFilter,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  clearExtraFilter,
  clearLobTeamAgent,
  setExtraFilter,
  handleRemoveMultipleExtraFilterDataFromApplied,
  setAllfilterFromParent,
  setSelectedDatafromParent,
  setNone,
  setNoneTeam,
  setNoneAgent
} from 'store/AnalyticsFilter';
import { selectorForSelectedFilter } from 'store/AnalyticsFilter/selector';

function useAnalyticsFilter() {
  const dispatch = useDispatch();

  const dateRange = useSelector((state) => state.analyticsfilter.rangeDate),
    LOB = useSelector((state) => state.analyticsfilter.LOB),
    none = useSelector((state) => state.analyticsfilter.none),
    noneTeam = useSelector((state) => state.analyticsfilter.noneTeam),
    noneAgent = useSelector((state) => state.analyticsfilter.noneAgent),
    selectedLOB = useSelector((state) => state.analyticsfilter.selected.LOB),
    ui = useSelector((state) => state.analyticsfilter.ui),
    LOBTeam = useSelector((state) => state.analyticsfilter.LOBTeam),
    LOBTeamAgent = useSelector((state) => state.analyticsfilter.LOBTeamAgent),
    flag = useSelector((state) => state.analyticsfilter.flag),
    filter = useSelector((state) => state.analyticsfilter.data),
    filters = useSelector((state) => state.analyticsfilter.data?.extra_filter),
    appliedExtraFilters = useSelector((state) => state.analyticsfilter.extra_filter),
    appliedFeatureFilters = useSelector((state) => state.analyticsfilter.features_filter),
    features_filter = useSelector((state) => state.analyticsfilter.data?.feature_filter),
    selectedFilter = useSelector(selectorForSelectedFilter),
    selectedFields = useSelector((state) => state.analyticsfilter.selected?.fields),
    selectedRowFilterFields = useSelector((state) => state.filter.selected?.rowFilter),
    fields = useSelector((state) => state.analyticsfilter.fields),
    call_duration = useSelector((state) => state.analyticsfilter.data?.extra_filter?.call_duration),
    tenure = useSelector((state) => state.analyticsfilter.data?.extra_filter?.tenure),
    shift = useSelector((state) => state.analyticsfilter.data?.extra_filter?.shift),
    direction = useSelector((state) => state.analyticsfilter.data?.extra_filter?.direction),
    skill_set = useSelector((state) => state.analyticsfilter.data?.extra_filter?.skill_set),
    tagging_feature = useSelector((state) => state.analyticsfilter.data?.extra_filter?.tagging_feature),
    exo_phone = useSelector((state) => state.analyticsfilter.data?.extra_filter?.exo_phone),
    fieldsConfig = useSelector((state) => state.analyticsfilter.fields_config),
    SelectedAgentData = useSelector((state) => state.analyticsfilter?.selected?.LOBTeamAgent?.username);

  const getAnalyticsConfigDataAction = () => dispatch(getAnalyticsConfigData()),
    changeDateRangeAction = (params) => dispatch(changeDateRange(params)),
    handleLobFilterChangeAction = (params) => dispatch(handleLobFilterChange(params)),
    handleTeamFilterChangeAction = (params) => dispatch(handleTeamFilterChange(params)),
    handleAgentFilterChangeAction = (params) => dispatch(handleAgentFilterChange(params)),
    handleSetExtraFilterDataAction = (params) => dispatch(handleSetExtraFilterData(params)),
    handleRemoveExtraFilterDataAction = (params) => dispatch(handleRemoveExtraFilterData(params)),
    handleSetMultipleExtraFilterDataAction = (params) => dispatch(handleSetMultipleExtraFilterData(params)),
    handleRemoveMultipleExtraFilterDataAction = (params) => dispatch(handleRemoveMultipleExtraFilterData(params)),
    handleSetMultipleFeatureFilterDataAction = (params) => dispatch(handleSetMultipleFeatureFilterData(params)),
    handleRemoveFeatureExtraFilterDataAction = (params) => dispatch(handleRemoveFeatureExtraFilterData(params)),
    handleChangeAddtionalFieldsAction = (params) => dispatch(handleChangeAddtionalFields(params)),
    handleChangeAddtionalSubFieldsAction = (params) => dispatch(handleChangeAddtionalSubFields(params)),
    setFeatureFilterAction = () => dispatch(setFeatureFilter()),
    setExtraFilterAction = () => dispatch(setExtraFilter()),
    clearExtraFilterAction = () => dispatch(clearExtraFilter()),
    clearLobTeamAgentAction = () => dispatch(clearLobTeamAgent()),
    handleRemoveMultipleExtraFilterDataFromAppliedAction = (params) => dispatch(handleRemoveMultipleExtraFilterDataFromApplied(params)),
    setAllfilterFromParentAction = (params) => dispatch(setAllfilterFromParent(params)),
    setSelectedDatafromParentAction = (params) => dispatch(setSelectedDatafromParent(params)),
    setNoneAction = (params) => dispatch(setNone(params)),
    setNoneTeamAction = (params) => dispatch(setNoneTeam(params)),
    setNoneAgentAction = (params) => dispatch(setNoneAgent(params));
  return {
    // state of Filter
    dateRange,
    LOB,
    ui,
    LOBTeam,
    LOBTeamAgent,
    flag,
    filter,
    filters,
    features_filter,
    selectedFilter,
    selectedFields,
    selectedRowFilterFields,
    call_duration,
    tenure,
    shift,
    direction,
    skill_set,
    tagging_feature,
    exo_phone,
    fields,
    fieldsConfig,
    appliedExtraFilters,
    appliedFeatureFilters,
    selectedLOB,
    SelectedAgentData,
    none,
    noneTeam,
    noneAgent,
    // Action of Filter
    getAnalyticsConfigDataAction,
    changeDateRangeAction,
    handleLobFilterChangeAction,
    handleTeamFilterChangeAction,
    handleAgentFilterChangeAction,
    handleChangeAddtionalFieldsAction,
    handleChangeAddtionalSubFieldsAction,
    handleSetExtraFilterDataAction,
    handleRemoveExtraFilterDataAction,
    handleSetMultipleExtraFilterDataAction,
    handleRemoveMultipleExtraFilterDataAction,
    handleSetMultipleFeatureFilterDataAction,
    handleRemoveFeatureExtraFilterDataAction,
    setFeatureFilterAction,
    setExtraFilterAction,
    clearExtraFilterAction,
    handleRemoveMultipleExtraFilterDataFromAppliedAction,
    setAllfilterFromParentAction,
    setSelectedDatafromParentAction,
    clearLobTeamAgentAction,
    setNoneAction,
    setNoneTeamAction,
    setNoneAgentAction
  };
}

export default useAnalyticsFilter;
